import { createContext, SetStateAction, Dispatch } from "react";

import { FormInstance } from "antd";

import { CoveragePerPlan, GenerateAPQuotationServiceResponse } from "../../../../../../../../../shared/interfaces";
import { ActivitiesForm, PaymentMethodForm, Variation } from "./StepThreeFormProvider";
import { QuotationButton } from "../../../../../shared/interfaces";

interface StepThreeFormContextProps {
    coveragesPerPlan:                       Array<CoveragePerPlan>;

    maxAndMinVariation:                     Variation | undefined;

    quotationResponse?:                     GenerateAPQuotationServiceResponse;
    setQuotationResponse:                   Dispatch<SetStateAction<GenerateAPQuotationServiceResponse | undefined>>;

    reQuotationResponse?:                   GenerateAPQuotationServiceResponse;
    setReQuotationResponse:                 Dispatch<SetStateAction<GenerateAPQuotationServiceResponse | undefined>>;

    labelButton:                            QuotationButton;
    setLabelButton:                         Dispatch<SetStateAction<QuotationButton>>;

    activitiesWithError:                    Array<string>;
    setActivitiesWithError:                 Dispatch<SetStateAction<Array<string>>>;

    activitiesForm:                         FormInstance<ActivitiesForm>;
    paymentMethodsForm:                     FormInstance<PaymentMethodForm>;

    setPaymentMethodFormValues:             Dispatch<SetStateAction<PaymentMethodForm | undefined>>;

    initialActivitiesForm:                  ActivitiesForm | undefined;
    setInitialActivitiesForm:               Dispatch<SetStateAction<ActivitiesForm | undefined>>;

    initialPaymentMethodForm:               PaymentMethodForm | undefined;

    //* Methods
    clearPrimaFieldsOnFormChange:           () => void;

    handlerOnClick:                         () => Promise<void>;
    
    activeTab:                              string;
    setActiveTab:                           React.Dispatch<React.SetStateAction<string>>;
}

export const StepThreeFormContext = createContext({} as StepThreeFormContextProps);